import cookies from "js-cookie";
import { StatusClassNames } from "../types/StatusClassNames";
import { onTransitionEnd } from "../utils";
export default function initCookieBox() {
    const cookieBox = document.querySelector('.cookie-box');
    const button = cookieBox?.querySelector('button');
    if (!cookieBox || !button) {
        return;
    }
    button.addEventListener('click', () => {
        cookies.set('cookie_clicked', '1', { path: '/', expires: 365 });
        cookieBox.classList.add(StatusClassNames.hide);
        onTransitionEnd(cookieBox, () => cookieBox.remove());
    });
}
